import styled from 'styled-components';

import Grid from '@klv/utils/grid';
import Typography from '@klv/atoms/typography';

export const StyledGrid = styled(Grid)``;

export const HeadlineContainer = styled.div`
  grid-column: 1 / -1;
  padding: 1.6rem 0;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      padding: 4rem 0;
    }
  `}
`;

export const Headline = styled(Typography)``;

export const StyledTwoColumnL30R70 = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  grid-column: 1 / -1;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      flex-direction: row;
    }
  `}
`;

export const LeftColumn = styled.div`
  width: 100%;
  height: auto;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      max-width: 38rem;
    }
  `}
`;
export const RightColumn = styled.div`
  width: 100%;
  height: auto;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      max-width: 86.8rem;
    }
  `}
`;

export const StyledDivider = styled.div`
  ${({ theme }) => `
    background-color: transparent;
    margin: 2.4rem 0;
    opacity: .2;
    
    ${theme.screenSize.s1024.mediaQuery} {
      display: block;
      background-color: ${theme.twoColumnL30R70.divider};
      min-height: 2rem;
      width: .2rem;
      margin: 0 2.4rem;
    }
  `}
`;
